import { keyframes } from 'styled-components';

const scaleMenuAnimationOpen = keyframes`
    from { transform: scale(0); }
    to {
        transition: transform 150ms cubic-bezier(0,0,0.2,1);
        transform: scale3d(1,1,1);
        visibility: visible;
    }
`;

const scaleMenuAnimationClose = keyframes`
    from {
        transition: transform 150ms cubic-bezier(0,0,0.2,1);
        transform: scale3d(1,1,1);
    }
    to { 
        transform: scale(0);
        visibility: hidden;
    }
`;

export {
    scaleMenuAnimationOpen,
    scaleMenuAnimationClose,
};
